<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="selectModule"
              :pageId="this.$options.name"
              :selectedMd="searchFrame.selectedCodeValue.moduleCode"
              :selectedSmd="searchFrame.selectedCodeValue.subModuleCode"
              defaultMdOption="select"
              :defaultSmdOption="'all'"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRMT_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectInterfaceTransmitTypeCode"
              :selected="searchFrame.selectedCodeValue.interfaceTransmitTypeCode"
              :pageId="this.$options.name"
              codeId="COD_IF_TRMT_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PROC_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="selectInterfaceProcessYn"
              :selected="searchFrame.selectedCodeValue.interfaceProcessYn"
              :optionList="processYn"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRD')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              ref="dp"
              :value="searchFrame.rangeDate"
              sticky
              @confirm="onRangeConfirm"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              ref="selectInterfaceSearchCond"
              :selected="searchFrame.selectedCodeValue.interfaceSearchCond"
              :pageId="this.$options.name"
              codeId="COD_IF_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              style="width:59%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="searchFrame.interfaceSearchWord"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="historyGrid"
        :dataset="'ds0'"
        :columns="gridColumns0"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
      />
      <div class="btn_moreView">
        <p
          :class="paging.totalCount === 0 || paging.count === paging.totalCount ? 'disabled' : ''"
          @click="addRows"
        >
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['interfaceProcessDTM'];

export default {
  name: 'PGE_CMS_00003', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      processYn: [{
        label: this.$t('MSG_TXT_SUC'),
        key: 'Y',
      }, {
        label: this.$t('MSG_TXT_FAIL'),
        key: 'N',
      }],
      searchFrame: {
        selectedCodeValue: {
          moduleCode: {
            key: '',
            label: '',
          },
          subModuleCode: {
            key: '',
            label: '',
          },
          interfaceTransmitTypeCode: {
            key: '',
            label: '',
          },
          interfaceProcessYn: {
            key: '',
            label: '',
          },
          interfaceSearchCond: {
            key: '',
            label: '',
          },
        },
        rangeDate: {
          from: utils.now('YYYY-MM-DD'),
          to: utils.now('YYYY-MM-DD'),
        },
        interfaceSearchWord: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_IF_ID'),
        datafield: 'interfaceId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.historyGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_IF_NM'),
        datafield: 'interfaceName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.historyGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_IF_PRTC_ID'),
        datafield: 'interfacePracticeId',
      }, {
        text: this.$t('MSG_TXT_PROC_DTM'),
        datafield: 'interfaceProcessDTM',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_PROC_YN'),
        datafield: 'interfaceProcessYnName',
        cellClassName: (r, c, v, h) => this.processYnClass(r, c, v, h),
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_ERR_CD'),
        datafield: 'interfaceErrorCode',
        width: '100px',
      }],
      paging: {
        count: 0,
        totalCount: 0,
        curPage: 0,
        searchData: {},
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    showMoreCount() {
      return `(${this.paging.count}/${this.paging.totalCount})`;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'interfaceId', map: 'interfaceId' },
      { type: 'string', name: 'interfaceName', map: 'interfaceName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'interfaceSendSystemName', map: 'interfaceSendSystemName' },
      { type: 'string', name: 'interfaceReceiptSystemName', map: 'interfaceReceiptSystemName' },
      { type: 'string', name: 'interfaceConnectionSystemName', map: 'interfaceConnectionSystemName' },
      { type: 'string', name: 'interfaceConnectionId', map: 'interfaceConnectionId' },
      { type: 'string', name: 'interfaceTransmitTypeCode', map: 'interfaceTransmitTypeCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'interfaceTransmitTypeName', map: 'interfaceTransmitTypeName' },
      { type: 'string', name: 'interfaceDivisionName', map: 'interfaceDivisionName' },
      { type: 'string', name: 'interfaceCommunicationTypeName', map: 'interfaceCommunicationTypeName' },
      { type: 'string', name: 'interfaceProcessTypeName', map: 'interfaceProcessTypeName' },
      { type: 'string', name: 'interfaceDataFormatName', map: 'interfaceDataFormatName' },
      { type: 'string', name: 'interfaceSearchCond', map: 'interfaceSearchCond' },
      { type: 'string', name: 'interfaceSearchWord', map: 'interfaceSearchWord' },
      { type: 'string', name: 'interfaceHistoryUid', map: 'interfaceHistoryUid' },
      { type: 'string', name: 'interfacePracticeId', map: 'interfacePracticeId' },
      { type: 'string', name: 'interfaceProcessDTM', map: 'interfaceProcessDTM' },
      { type: 'string', name: 'interfaceProcessYn', map: 'interfaceProcessYn' },
      { type: 'string', name: 'interfaceProcessYnName', map: 'interfaceProcessYnName' },
      { type: 'string', name: 'interfaceErrorCode', map: 'interfaceErrorCode' },
      { type: 'string', name: 'interfaceErrorContent', map: 'interfaceErrorContent' },
      { type: 'string', name: 'interfacePracticeContent', map: 'interfacePracticeContent' },
    ],
  }],
  mounted() {
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    onGridSingleButtonClicked(value, dataRow) {
      this.onHistoryDetailClick(dataRow);
    },
    onResetClick() {
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'select')) {
          if (utils.isEqual(key, 'selectModule')) {
            ref.selectMd(' ');
          } else {
            ref.reset();
          }
        }
      });
      this.searchFrame.interfaceSearchWord = '';
      this.searchFrame.rangeDate = {
        from: utils.now('YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      };
    },
    onRangeConfirm(value) {
      this.searchFrame.rangeDate = utils.assign(value);
    },
    getSearchData() {
      const data = {
        curPage: 1,
      };
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = utils.trim(codeValue.key);
          });
        } else if (utils.isEqual(key, 'rangeDate')) {
          utils.assign(data, this.getRangeDate(value));
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    getRangeDate(value) {
      const { from, to } = value;
      const processingPeriodStartDTM = utils.isDate(from) ? utils.dateformatToServer(from) : '';
      const processingPeriodEndDTM = utils.isDate(to) ? utils.dateformatToServer(to, 'S').concat('235959') : '';

      return { processingPeriodStartDTM, processingPeriodEndDTM };
    },
    onSearchClick() {
      if (this.onClickValidate()) return;
      if (utils.isEmpty(utils.trim(this.searchFrame.selectedCodeValue.moduleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
      } else {
        this.paging.curPage = 1;
        this.paging.searchData = this.getSearchData();
        this.searchAction(false);
      }
    },
    addRows() {
      if (this.paging.count < this.paging.totalCount) {
        this.paging.curPage += 1;
        this.paging.searchData.curPage = this.paging.curPage;
        this.searchAction(true);
      }
    },
    searchAction(addRow) {
      http.request(this.$options.name, 'DTS_CMS_00046', {
        query: this.paging.searchData,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        if (addRow) {
          this.paging.count += res.data.length;
          const union = utils.mergeArray(this.ds0.data, res.data);
          this.ds0.setRawData(union);
        } else if (res.data.length > 0) {
          this.paging.totalCount = res.data[0].totalCount;
          this.paging.count = res.data.length;
          this.ds0.setRawData(res.data);
        } else {
          this.paging.totalCount = 0;
          this.paging.count = 0;
          this.ds0.setRawData([]);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onHistoryDetailClick(data) {
      utils.openLayerPopup('PGE_CMS_00008', this.onInterfaceHistoryPopupClose, {
        pageInitialData: {
          interfaceData: data,
        },
        size: 'lg',
      });
    },
    onInterfaceHistoryPopupClose() {
      this.ds0.clearSelection();
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
    processYnClass(row, column, value, htmlElement) {
      if (utils.isEqual(htmlElement.interfaceProcessYn, 'N')) {
        return 'RE_error';
      }
      return '';
    },
  },
};
</script>
<style scoped>
</style>
